<template>
  <div class="layout-header">
    <div class="header-content">
      <div class="header-left">
        <div class="header-logo-wrapper">
          <img class="header-logo" src="../../assets/logo.png">
        </div>
        <div class="header-system">
          {{ $t("global.title1")}}
          <br>{{ $t("global.title2")}}
        </div>
      </div>
      <div class="header-right">
        <div>
          <el-badge :is-dot='spot' class="item">
            <i class="el-icon-ali-tongzhi" style="color:#B6C6D0;font-size:20px;" @click="news" />
          </el-badge>
        </div>
        <div class="header-language">
          <lang-switcher />
        </div>
        <div>
          <el-dropdown @command="handleCommand">
            <div class="el-dropdown-link">
              <headimg
                :size="40"
                :src="headImage"
              />
              <!-- <span style="width:40px;height:40px;border-radius:50%;background-color:red;display:block" ></span> -->
              <span class="username">{{ $store.state.user.userinfo.loginName }}</span>
              <i class="el-icon-arrow-down el-icon--right" />
            </div>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="changepwd">
                <span>{{ changePassword }}</span>
              </el-dropdown-item>
              <el-dropdown-item command="logout">
                <span>{{ Logout }}</span>
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>        
        <div v-if="false">
          <!--角色-->
          <el-dropdown @command="handleRoleCommand">
            <div class="el-dropdown-link">
              <!-- <el-avatar class="avatar-icon" size="small" shape="square" icon="el-icon-user-solid" /> -->   
              <span style="height:40px;"></span>           
              <span class="rolename">{{ roleCur.roleName }}</span>
              <i class="el-icon-arrow-down el-icon--right" />
            </div>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item
                v-for="item in roleList"
                :key="item.id"
                :command="item"
              ><span :style="roleCur.id === item.id?'color:#66b1ff':''">{{ item.roleName }}</span></el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </div>
    </div>
    <div class="header-footer" />
  </div>
</template>

<script>
import { loginOut, sysNoticeSelectNoReadNotice } from '../../api/login'
// import { roleSelectUser, userUpdateUserRole } from '@/api/adminManagement'
export default {
  components: {},
  mixins: [],
  props: {},
  data() {
    return {
      admin: '',
      spot: false,
      changePassword:'',
      Logout:'',
      headImage:'',
      roleList: [], // 角色列表
      roleCur: {} // 当前角色
    }
  },
  created() {},
  computed: {
    lang() {
      return this.$store.state.app.language
    },
  },
  watch: {
    lang() {
      this.langtxt()
    }
  },
  mounted() {
    if(this.$store.state.user.userinfo.headImage){
      this.headImage = this.$store.state.user.userinfo.headImage
    }else{
      this.headImage = require('../../assets/phone.jpg')
    }
    this.langtxt()
    this.sysNotice()
    this.loadRoleList()
  },
  destroyed() {},
  methods: {
    into() {
      const data = JSON.parse(localStorage.getItem('userData'))
      this.admin = data.loginName
    },

    langtxt(){
      this.changePassword = this.$t("menu.changePassword")
      this.Logout = this.$t("administration.Logout")
    },

    news() {
      this.sysNotice();
      this.$router.push({
        name: 'stationNewsIndex'
      })
    },
    // 修改密码
    changePasswordBtn() {
      this.$router.push({
        name: 'changePassword'
      })
    },
    sysNotice(){
      sysNoticeSelectNoReadNotice({}).then(response => {
        if (response.code == 200) {
          this.spot = response.data
        }
      })
    },
    // 退出登录
    logOut() {
      const param = {
        token: this.$store.state.user.userinfo.token
      }
      loginOut(param).then(response => {
        if (response.code == 200) {
          this.$message({
            message: response.message,
            type: 'success'
          })
        }
      })
      .finally(() => {      
          this.$store.commit('setUserInfo', {})

          this.$router.push({
            path: '/login'
          })
      })
    },
    handleCommand(command){
      if(command === "changepwd"){
        this.changePasswordBtn()
      }else{
        this.logOut()
      }
    },
    loadRoleList() {
      // 加载角色列表
      // roleSelectUser()
      //   .then(result => {
      //     if (result.code == 200) {
      //       const roleList = result.data
      //       this.roleList = roleList
      //       const userData = this.$store.state.user.userinfo//JSON.parse(localStorage.getItem('userData'))
      //       if (userData != undefined && userData != null) {
      //         const roleId = userData.roleId
      //         if (
      //           roleList != undefined &&
      //           roleList != null &&
      //           roleList.length
      //         ) {
      //           let roleCur = null
      //           for (let i = 0; i < roleList.length; i++) {
      //             const roleTemp = roleList[i]
      //             if (roleTemp.id === roleId) {
      //               roleCur = roleTemp
      //               break
      //             }
      //           }
      //           if (roleCur == null) {
      //             roleCur = { id: roleId, roleName: '' }
      //           }
      //           this.roleCur = roleCur
                
      //           this.admin = userData.loginName
      //           // console.log(this.roleCur)
      //         }
      //       }
      //     } else {
      //       this.$message({
      //         type: 'error',
      //         message: result.message
      //       })
      //     }
      //   })
      //   .catch(() => {
      //   })
    },
    handleRoleCommand(command) {
      // 角色下拉列表指令
      // userUpdateUserRole(command.id)
      //   .then(result => {
      //     if (result.code == 200) {
      //       if (this.roleCur.id === command.id) {
      //         // 选择项为当前项，不做改变
      //         return
      //       }
      //       this.roleCur = command // 更新当前角色
      
      //       const data = this.$store.state.user.userinfo//JSON.parse(localStorage.getItem('userData'))
      //       this.admin = data.loginName
      //       //console.log(this.roleCur)
      
      //       this.updateUserRoleId(command.id) // 更新当前缓存的用户信息中的默认角色id
      //       this.clearPermissionList() // 清空权限列表
      //       // this.$router.push({name:'layout',query:{isReload:true}})
      //       // this.$router.go(0);
      //       // if (this.$route.name !== 'layout') {
      //       window.location.href = window.location.href.replace(this.$route.fullPath, '/welcome') + '?isRoleHome=true'
      //       // }
      //       window.location.reload()
      //     } else {
      //       this.$message({
      //         type: 'error',
      //         message: result.message
      //       })
      //     }
      //   })
      //   .catch(() => {
      //   })
    }
  }
}
</script>
<style lang="scss" scoped>
.el-dropdown-link {
  display: flex;
  align-items: center;

  .username {
    margin-left: 14px;
    font-size: 13px;
    color: #999999;
  }

  .rolename {
    margin-left: 14px;
    font-size: 13px;
    color: #999999;
  }
}

.layout-header {
  height: 90px;
  -moz-user-select: none;
  -webkit-user-select: none;
  user-select: none;

  .header-content {
    height: 77px;
    display: flex;
    justify-content: space-between;

    .header-left {
      height: 77px;
      padding-left: 26px;
      display: flex;
      align-items: center;

      .header-logo-wrapper {
        width: 53px;
        img {
          width: 100%;
        }
      }

      .header-system {
        margin-left: 14px;
        font-size: 21px;
        //font-family: Arial-BoldMT, Arial;
        font-weight: bolder;
        color: rgba(15, 120, 188, 1);
        line-height: 25px;
      }
    }

    .header-right {
      height: 100%;
      display: flex;
      align-items: center;
      margin-right: 20px;

      & > div {
        margin-right: 27px;
        cursor: pointer;
      }

      div.header-language {
        font-size: 13px;
        font-family: PingFangSC-Regular, PingFangSC;
        font-weight: normal;
        color: rgba(204, 204, 204, 1);

        .lang-selected {
          color: blue;
        }
      }
    }
  }

  .header-footer {
    height: 13px;
    background: rgba(5, 124, 191, 1);
  }
}
</style>
